import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import AccountScreen from "@/screens/Account/AccountScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  return <AccountScreen {...props} />;
}

export default withSessionHandling(Page);
